unit CategoryListType;

interface

uses
  CategoryType;

type
  TCategoryListType = array of TCategoryType;

implementation

end.
